import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Resultimpact() {
  return (
    <section className="result_impact_milo p-100 text_reck">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Results and <span>Impact</span>
            </h2>
            <p>
              The Reck’N app redefined the restaurant experience for customers
              and eateries alike. Customers benefited from a modernized booking
              process, suitable order pickup, and the opening to connect with
              fellow diners. The socialization component added a new layer to
              dining out, making it more engaging and collaborative.
            </p>
            <p>
              Contrary, restaurants experienced perceptible benefits. Sales
              enhancement through customer tracking emphasized the worth of
              understanding diner preferences. Treating regular customers
              heightened loyalty and strengthened relationships, conducive to
              continued business growth.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="client_img">
              <StaticImage
                src="../../../images/case-studies/reckncase/result.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={789}
                height={530}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Resultimpact;
